// =============================================
// Hebrew Calendar Utilities
// KipiKid - עזרי לוח שנה בעברית
// =============================================

export const HEBREW_DAYS = ['א׳', 'ב׳', 'ג׳', 'ד׳', 'ה׳', 'ו׳', 'ש׳'];

export const HEBREW_MONTHS = [
  'ינואר', 'פברואר', 'מרץ', 'אפריל',
  'מאי', 'יוני', 'יולי', 'אוגוסט',
  'ספטמבר', 'אוקטובר', 'נובמבר', 'דצמבר',
];

/** Format year/month(0-based)/day into "yyyy-MM-dd" */
export function formatDate(year: number, month: number, day: number): string {
  const mm = String(month + 1).padStart(2, '0');
  const dd = String(day).padStart(2, '0');
  return `${year}-${mm}-${dd}`;
}

/** Parse "yyyy-MM-dd" into { year, month (0-based), day } */
export function parseDate(dateStr: string): { year: number; month: number; day: number } {
  const parts = dateStr.split('-');
  return { year: parseInt(parts[0]), month: parseInt(parts[1]) - 1, day: parseInt(parts[2]) };
}

/** Format "yyyy-MM-dd" as Hebrew display string e.g. "3 מרץ" */
export function formatDisplayDate(dateStr: string): string {
  const { day, month } = parseDate(dateStr);
  return `${day} ${HEBREW_MONTHS[month]}`;
}

/** Number of days in a given month (0-based month) */
export function daysInMonth(year: number, month: number): number {
  return new Date(year, month + 1, 0).getDate();
}

/** Day of week the month starts on (0=Sunday) */
export function firstDayOfMonth(year: number, month: number): number {
  return new Date(year, month, 1).getDay();
}

/** Check if a Date is today */
export function isToday(date: Date): boolean {
  const now = new Date();
  return (
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate()
  );
}

/** Check if a Date is Saturday (Shabbat) */
export function isSaturday(date: Date): boolean {
  return date.getDay() === 6;
}
